<template>
  <div>
    <api-table-block ref="registrationTable" :fields="fields" :items="loadHourRegistrations" default-sort-by="placed_at" item-label-singular="urenregistratie" item-label-plural="Urenregistraties" :hideSearchBar="true">
      <template slot="created_at" slot-scope="data">
        {{data.value | moment('calendar') | capitalize}}
      </template>
      <template slot="display_start" slot-scope="data">
        <span v-if="data.item.editing">
          <b-input v-model="data.item.temp['display_start']"></b-input>
        </span>
        <span v-else>
          {{data.value}}
        </span>
      </template>
      <template slot="display_stop" slot-scope="data">
        <span v-if="data.item.editing">
          <b-input v-model="data.item.temp['display_stop']"></b-input>
        </span>
        <span v-else>
          {{data.value}}
        </span>
      </template>
      <template slot="hours_worked" slot-scope="data">
        {{data.value}}
      </template>
      <template slot="actions" slot-scope="data">
        <div v-if="!data.item.editing" class="btn-group" role="group">
          <button class="btn btn-sm btn-secondary  ml-3" @click="deleteEntry(data.item.id)">Verwijderen</button>
          <button v-if="role === 'admin'" class="btn btn-sm btn-secondary  ml-3" @click="doEdit(data.item)">Edit</button>
        </div>
        <div v-else class="btn-group" role="group">
          <button class="btn btn-sm btn-secondary  ml-3" @click="doCancel(data.item)">Cancel</button>
          <button class="btn btn-sm btn-secondary  ml-3" @click="doSave(data.item)">Save</button>
        </div>
      </template>
    </api-table-block>
  </div>
</template>

<script>
import ApiTableBlock from '../common/ApiTableBlock'

export default {
  components: {
    ApiTableBlock
  },
  props: {
    userId: Number,
    role: String
  },
  data () {
    return {
      fields: {
        created_at: {
          label: 'Datum',
          thStyle: 'width: 20%;'
        },
        display_start: {
          label: 'Start',
          thStyle: 'width: 20%;',
          editable: true
        },
        display_stop: {
          label: 'Stop',
          thStyle: 'width: 20%;',
          editable: true
        },
        hours_worked: {
          label: 'Aantal uur gewerkt',
          thStyle: 'width: 20%;'
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 20%;'
        }
      }
    }
  },
  computed: {
    registrationTable () {
      return this.$refs.registrationTable
    }
  },
  methods: {
    loadHourRegistrations (params) {
      return this.$api.getHourRegistrations(this.userId, params)
    },
    refresh () {
      this.registrationTable.refresh()
    },
    doEdit (item) {
      this.$set(item, 'temp', JSON.parse(JSON.stringify(item)))
      this.$set(item, 'editing', true)
    },
    doSave (item) {
      const data = {
        'started_at': item.temp['display_start'],
        'stopped_at': item.temp['display_stop'],
        'created_at': item.temp['created_at']
      }

      this.$http.patch(`/hour-registrations/${item.id}`, data)
      .then((result) => {
        this.$swal('Hoera 😊', `De uren registratie is succesvol bijgewerkt.`, 'success')
        this.$set(item, 'editing', false)
        this.refresh()
      })
      .catch(() => {
        this.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze uren registratie. Probeer het opnieuw.', 'warning')
      })
    },
    doCancel (item) {
      this.$set(item, 'editing', false)
      this.$delete(item, 'temp')
    },
    deleteEntry (id) {
      this.$http.delete(`/hour-registration/${id}`)
      .then((response) => {
        this.refresh()
      })
      .catch(() => {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het verwijderen Probeer het opnieuw.`, 'error')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// HourRegistrationTable.vue?1bf48944